import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Produto } from 'src/app/model/produto';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { ToastService } from 'src/app/core/toast.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-gerenciar-estoque',
  templateUrl: './gerenciar-estoque.page.html',
  styleUrls: ['./gerenciar-estoque.page.scss'],
})
export class GerenciarEstoquePage implements OnInit {

  products1: Produto[];

  products2: Produto[];

  idCategoria;

  clonedProducts: { [s: string]: Produto; } = {};

  constructor(private route: ActivatedRoute, private productService: ProdutoapiService, private toast: ToastService) { }

  ngOnInit() {

    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      // tslint:disable-next-line: radix
      this.idCategoria = parseInt(idParam);
      // tslint:disable-next-line: radix
      this.productService.GetByCat(parseInt(idParam)).then(data => this.products1 = data);
      // tslint:disable-next-line: radix
      this.productService.GetByCat(parseInt(idParam)).then(data => this.products2 = data);
    }
  }

  onRowEditInit(product: Produto) {
    this.clonedProducts[product.id] = { ...product };
  }

  onRowEditSave(product: Produto) {
    if (product.estoque > 0) {
      delete this.clonedProducts[product.id];
      this.productService.editarEstoque(product);
      this.toast.showSucess('Editado com Sucesso!');
    } else {
      this.toast.showError('Erro ao editar, Estoque inválido!');
    }
  }

  mudastts(prod: Produto) {
    const novoStatus = !prod.ativo;
    prod.ativo = novoStatus;
    this.productService.atualizar(prod)
       .then(() => {
         const acao = novoStatus ? 'ativado' : 'desativado';
         prod.ativo = novoStatus;
         this.toast.showSucess(`Produto ${acao} com sucesso!`);
       })
       .catch(erro => {
         console.log(erro);
         this.toast.showError('Erro ao Alterar Status');
       });
    
    }

  onRowEditCancel(product: Produto, index: number) {
    this.products2[index] = this.clonedProducts[product.id];
    delete this.products2[product.id];
    this.productService.GetByCat(this.idCategoria).then(data => this.products2 = data);
  }

}

